export default __webpack_public_path__ + "static/media/host_screenShare_active.6029176c.svg";